<template>
    <div>
        <div class="banner"></div>
        <div class="content">
            <div class="contentCom">
                <el-row>
                    <el-col :span="5">
                        <div class="title">
                            公示通知 <br/>
                            <span style="font-size:16px;">
                                Public Notice
                            </span>
                        </div>
                        <div class="menu">
                            <div class="qygkContent">
                                <div v-for="(item,index) in menuList" :key="item.parentType" @click="tab(item)" class="name" :class="{'active':item.active}">
                                    {{item.parentTypeName}}
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="18" :offset="1">
                        <div class="nrTitle">
                            {{titleName}}
                        </div>
                        <div class="mainContent">
                            <div class="list" v-for="(item,index) in listData" :key="index" @click="goDetail(item)">
                                <div class="word">
                                    {{ item.noticeTitle }}
                                </div>
                                <div class="time">
                                    <i class="el-icon-time"></i>
                                    <div>
                                        {{ item.createTime }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="page">
                            <el-pagination
                                layout="prev, pager, next"
                                :total="total"
                                @current-change="changePage"
                                >
                            </el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment"
export default {
    data() {
        return {
            page:'',
            titleName:'',
            menuList:[
            ],
            listData: [
            ],
            total: 0
        }
    },
    mounted() {
        this.getMenu()
        if (this.$route.query) {
            if (this.$route.query.page) {
                this.page = this.$route.query.page
            }
            this.menuList.forEach(val => {
                val.active = false
                if (val.url == this.page) {
                    val.active = true
                    this.titleName = val.name
                }
            });
        }
    },
    methods: {
        goDetail(item){
            this.$router.push({
                path:'/detail',
                query:{
                    id:item.id
                    // title:item.noticeTitle,
                    // content:item.noticeContent,
                },
            })
        },
        async getData(num,size,type){
            var data = {
                noticeType: '2',
                pageNum:num,
                pageSize:size,
                parentType:type
            }
            const {data:res} = await this.$autPost(data,this.$getDataUrl)
            this.listData = res.rows
            this.listData.forEach(val => {
                val.createTime = moment(val.createTime).format('YYYY-MM-DD')
            });
            this.total = res.total
        },
        async getMenu(){
            var data = {
                noticeType: '2'
            }
            const {data:res} = await this.$autPost(data,this.$getMenuUrl)
            this.menuList = res.rows
            this.page = res.rows[0].parentType
            this.titleName = res.rows[0].parentTypeName
            this.getData(1, 10, res.rows[0].parentType)
            this.menuList.forEach((val, index) => {
                val.active = false
                if (index === 0) {
                    val.active = true
                }
            });
        },
        changePage(num) {
            this.getData(num, 10, this.page)
        },
        tab(item){
            this.menuList.forEach(val => {
                val.active = false
            });
            this.titleName = item.parentTypeName
            this.page = item.parentType
            item.active = true
            this.$router.push({
                path:'/publicity',
                query:{
                    page:item.parentType,
                },
            })
            this.getData(1, 10, item.parentType)
        },
    },
}
</script>

<style scoped>
    .banner {
        width: 1400px;
        margin: 0 auto;
        background: url(../assets/images/banner.jpg);
        height: 306px;
    }
     @media screen and (max-width: 1366px){
        .banner {
            width: 100%;
        }
    }
    .content {
        margin-top: 20px;
    }
    .contentCom {
        margin: 20px auto 50px;
        width: 1200px;
    }
    .title{
        background: #49A8F8;
        color: white;
        font-size: 20px;
        width: 100%;
        text-align: center;
        padding: 30px 0 20px;
    }
    .menu{
        width: 100%;
        text-align: center;
        font-size: 16px;
    }
    .qygkContent{
        background: #49A8F8;
        width: 100%;
        border-top: 1px dashed white;
        padding-bottom: 20px;
    }
    .name{
        width: 80%;
        margin: 0 auto;
        color: white;
        padding: 15px 0;
        border-bottom: 1px dashed white;
        cursor: pointer;
    }
    .name.active{
        color: #49A8F8;
        width: 100%;
        background: #eff7ff;
    }
    .nrTitle{
        width: 100%;
        font-size: 20px;
        color: #323232;
        padding:10px 0;
        border-bottom: 1px solid #aeaeae;
        font-weight: bold;
    }
    .mainContent {
        width: 100%;
    }
    .list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        border-bottom: 1px dashed #DCDFE6;
        padding: 10px 0;
        color: #606266;
        cursor: pointer;
    }
    .word {
        width: 80%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .time {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 10%;
        color: #909399;
        font-size: 14px;
    }
    .page {
        text-align: center;
        padding-top: 20px;
    }
</style>